import { render, staticRenderFns } from "./TreatmentPlanRequest.vue?vue&type=template&id=53fcf8a3&scoped=true&"
import script from "./TreatmentPlanRequest.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequest.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequest.vue?vue&type=style&index=0&id=53fcf8a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fcf8a3",
  null
  
)

export default component.exports